module.exports = "<app-page-header title=\"BILLING\" icon=\"credit_card\"></app-page-header>"